import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { errorHandler } from '../utils/ErrorHandler';

export const useServiceQuery = () => {
  const axios = useAxios();

  const handleFetchService = () => axios.get<AxiosResponse<ServiceProps[]>>(ApiRoutes.services);

  return useQuery(['service'], handleFetchService, {
    select: res => res.data.data,
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    staleTime: USE_QUERY_CONSTANTS.staleMs,
    refetchOnWindowFocus: USE_QUERY_CONSTANTS.refetchOnWindowFocus,
    retry: USE_QUERY_CONSTANTS.retry,
    onError: error => {
      errorHandler({ error });
    },
  });
};
